import {executeWithIntercept} from "@/helpers/CypressHelper";
import ReportDefinitionPage from "@/tests/pages/ReportDefinitionPage";
import Localizer from "@/localization/Localizer";

class ReportDefinitionsPage {
    public elements = {
        reportDefinitionsList: () => cy.get('[id="reportDefinitionsList"]'),
        definitionTypeDropdown: () => cy.get('[id="reportDefinitionTypeDD"]'),
        showDeleted: () => cy.get('[id="checkBoxShowDeleted"]'),
        add: () => cy.get('[id="addReportDefinition"]'),
        reportDefinitionsTabsContainer: () => cy.get('[id="reportDefinitionsTabs"]'),
        returnInspectionDefinitionsTab: () => cy.get('[id="tab_returnInspectionDefinitionsTab"]'),
        serviceDefinitionsTab: () => cy.get('[id="tab_serviceDefinitionsTab"]'),
    }

    public routes = {
        getReportDefinitions: {
            path: "/api/reportDefinition/getReportDefinitions",
            method: "POST",
        }
    };

    public constants = {
        triggerDefinitionName: "Service report definition for trigger tests"
    }

    public chooseType(value: string): void {
        cy.window()
            .then(win => {
                if (win.innerWidth < 768) {
                    this.elements.definitionTypeDropdown().click();
                    cy.wait(150)
                    this.elements.definitionTypeDropdown().contains(value).click();
                    this.elements.definitionTypeDropdown().click();
                } else {
                    this.elements.reportDefinitionsTabsContainer()
                        .within(() => {
                            if (value == Localizer.enumReportDefinitionTypeReturnInspection) {
                                this.elements.returnInspectionDefinitionsTab().click();
                            } else {
                                this.elements.serviceDefinitionsTab().click();
                            }
                        });
                }
            });
    }

    public goToTriggerDefinition(): void {
        executeWithIntercept(() =>
                cy.contains(this.constants.triggerDefinitionName).realClick(),
            [ReportDefinitionPage.routes.getServiceActions])
    }
}

export default new ReportDefinitionsPage();